import type { CarouselCardRowProps } from "./carousel-card-row.type";
import styles from "./carousel-card-row.module.css";

export const CarouselCardRow = ({ label, value, strong }: CarouselCardRowProps) => (
  <div className={styles.row}>
    <span className={styles.label}>{label}</span>
    <span className={`${styles.value} ${strong ? styles["value-strong"] : ""}`}>
      {value}
    </span>
  </div>
);
